export default __webpack_public_path__ + "static/media/rs-logo.638b1dc4.png";